import React, { useEffect, useState } from "react";
import Drawer from "@mui/material/Drawer";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import SpaRoundedIcon from "@mui/icons-material/SpaRounded";
import SelfImprovementRoundedIcon from "@mui/icons-material/SelfImprovementRounded";
import PollRoundedIcon from "@mui/icons-material/PollRounded";
import LocalLibraryRoundedIcon from "@mui/icons-material/LocalLibraryRounded";
import { MdGroups } from "react-icons/md";
import { IoMdList } from "react-icons/io";
import theme from "../../Theme/AppTheme";
export const Sidebar = () => {
  const location = useLocation();
  // const path = location.pathname ;
  const userData =
    localStorage.getItem("userdata") || JSON.stringify({ image: "", tabs: [] });
  const image = JSON.parse(userData).image;
  const accessibleTabs = JSON.parse(userData).tabs;
  const access_code = JSON.parse(userData).accessCode;
  const navigate = useNavigate();
  const [hoveredTabIndex, setHoveredTabIndex] = useState<number | null>(null);
  const [selectedTab, setSelectedTab] = useState<number>(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };
  const tabStyle: React.CSSProperties = {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "flex-start",
    padding: "12px",
    cursor: "pointer",
  };
  const hoverStyle: React.CSSProperties = {
    color: "#e76943 !important",
    fontWeight: theme.typography.h1.fontWeight,
  };
  const activeStyle: React.CSSProperties = {
    backgroundColor: "#fcece8",
    color: "#e76943 !important",
    fontWeight: theme.typography.fontWeightBold,
  };
  const handleNavigate = (path: string) => {
    navigate(path);
  };
  const labelWithIcon = (label: string, icon: React.ReactNode) => (
    <div style={{ ...tabStyle }}>
      {icon}
      <span style={{ marginLeft: "15px", textTransform: "none" }}>{label}</span>
    </div>
  );

  useEffect(() => {
    const setTabFromPath = (path: any) => {
      if (accessibleTabs.includes("employees")) {
        switch (path) {
          case "/":
            setSelectedTab(0);
            break;
          case "/therapy-sessions":
            setSelectedTab(1);
            break;
          case "/self-care":
            setSelectedTab(2);
            break;
          case "/survey":
            setSelectedTab(3);
            break;
          case "/group-sessions":
            setSelectedTab(4);
            break;
          case "/employees":
            setSelectedTab(5);
            break;
          case "/yoga-session":
            setSelectedTab(6);
            break;
          default:
            setSelectedTab(0);
            break;
        }
      } else if (accessibleTabs.includes("yogasession")) {
        switch (path) {
          case "/yoga-session":
            setSelectedTab(0);
            break;
          case "/":
            setSelectedTab(0);
            break;
          case "/therapy-sessions":
            setSelectedTab(2);
            break;
          case "/self-care":
            setSelectedTab(3);
            break;
          case "/survey":
            setSelectedTab(4);
            break;
          case "/group-sessions":
            setSelectedTab(5);
            break;
          default:
            setSelectedTab(0);
            break;
        }
      } else {
        switch (path) {
          case "/":
            setSelectedTab(0);
            break;
          case "/therapy-sessions":
            setSelectedTab(1);
            break;
          case "/self-care":
            setSelectedTab(2);
            break;
          case "/survey":
            setSelectedTab(3);
            break;
          case "/group-sessions":
            setSelectedTab(4);
            break;
          case "/yoga-session":
            setSelectedTab(5);
            break;
          default:
            setSelectedTab(0);
            break;
        }
      }
    };

    setTabFromPath(location.pathname);
  }, [location.pathname]);

  return (
    <div className="sidebar">
      {/* Sidebar */}
      <Drawer
        variant="permanent"
        sx={{
          width: 320,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: 320,
            boxSizing: "border-box",
          },
        }}
      >
        {/* <Toolbar /> */}
        <div>
          <div
            className={
              image ? "sidebar-logo-container" : "sidebar-logo-container2"
            }
          >
            <div>
              <img
                src="/images/manoshala_logo.png"
                alt="Logo 1"
                className="sidebar-logo1"
              />
              <div
                className="sidebar-logo-text"
                style={{
                  fontFamily: "Susan Classic W01 Bold, sans-serif",
                }}
              >
                MANOSHALA
              </div>
            </div>
            {image && (
              <>
                <div className="sidebar-divider" />
                <img
                  src={image}
                  alt="Logo 2"
                  style={{ flex: 1, maxWidth: "120px" }}
                />
              </>
            )}
          </div>

          {accessibleTabs.includes("all") ? (
            <Tabs
              orientation="vertical"
              value={selectedTab}
              onChange={handleTabChange}
              variant="scrollable"
              sx={{
                color: "#e76943 !important",

                "& .Mui-selected": activeStyle,
                "& :hover": hoverStyle,
              }}
            >
              <Tab
                style={tabStyle}
                onClick={() => handleNavigate("/")}
               
                label={labelWithIcon("Dashboard", <DashboardRoundedIcon />)}
              />

              <Tab
                style={tabStyle}
                onClick={() => handleNavigate("/therapy-sessions")}
                 disabled={access_code === "army123"}
                label={labelWithIcon("Therapy Sessions", <SpaRoundedIcon />)}
              />
              <Tab
                style={tabStyle}
                onClick={() => handleNavigate("/self-care")}
                 disabled={access_code === "army123"}
                label={labelWithIcon(
                  "Self-Help",
                  <SelfImprovementRoundedIcon />
                )}
              />
              <Tab
                style={tabStyle}
                onClick={() => handleNavigate("/survey")}
                disabled={access_code === "army123"}
                label={labelWithIcon("Assessments", <PollRoundedIcon />)
                }
              />
              <Tab
                style={tabStyle}
                 disabled={access_code === "army123"}
                onClick={() => handleNavigate("/group-sessions")}
                label={labelWithIcon("Group Sessions", <GroupsRoundedIcon />)}
              />
              {accessibleTabs.includes("employees") && (
                <Tab
                  style={tabStyle}
                disabled={access_code === "army123"}
                  onClick={() => handleNavigate("/employees")}
                  label={labelWithIcon("Employees", <IoMdList />)}
                />
              )}
              <Tab
                style={tabStyle}
                disabled
                onClick={() => handleNavigate("/yoga-session")}
                label={labelWithIcon("Yoga Session Attendance", <MdGroups />)}
              />
              <Tab
                style={tabStyle}
                disabled
                // onClick={() => handleNavigate("/community")}
                label={labelWithIcon(
                  "Community (Upcoming)",
                  <LocalLibraryRoundedIcon />
                )}
              />
            </Tabs>
          ) : (
            <Tabs
              orientation="vertical"
              value={selectedTab}
              onChange={handleTabChange}
              variant="scrollable"
              sx={{
                color: "#e76943 !important",

                "& .Mui-selected": activeStyle,
                "& :hover": hoverStyle,
              }}
            >
              <Tab
                style={tabStyle}
                onClick={() => handleNavigate("/yoga-session")}
                label={labelWithIcon("Yoga Session Attendance", <MdGroups />)}
              />
              <Tab
                style={tabStyle}
                disabled
                onClick={() => handleNavigate("/")}
                label={labelWithIcon("Dashboard", <DashboardRoundedIcon />)}
              />

              <Tab
                style={tabStyle}
                disabled
                onClick={() => handleNavigate("/therapy-sessions")}
                label={labelWithIcon("Therapy Sessions", <SpaRoundedIcon />)}
              />
              <Tab
                style={tabStyle}
                disabled
                onClick={() => handleNavigate("/self-care")}
                label={labelWithIcon(
                  "Self-Help",
                  <SelfImprovementRoundedIcon />
                )}
              />
              <Tab
                style={tabStyle}
                onClick={() => handleNavigate("/survey")}
                disabled
                label={labelWithIcon("Assessments", <PollRoundedIcon />)}
              />
              <Tab
                style={tabStyle}
                onClick={() => handleNavigate("/group-sessions")}
                disabled
                label={labelWithIcon("Group Sessions", <GroupsRoundedIcon />)}
              />
              <Tab
                style={tabStyle}
                // onClick={() => handleNavigate("/community")}
                disabled
                label={labelWithIcon(
                  "Community (Upcoming)",
                  <LocalLibraryRoundedIcon />
                )}
              />
            </Tabs>
          )}
        </div>
      </Drawer>
    </div>
  );
};
